import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { Inject, Injectable, Pipe, PipeTransform } from '@angular/core';

/**
 * Translate extension pipe, it is a wrapper of `translate` pipe, it locally injects L10N_LOCALE to overcome the
 * injection on each component that uses @Language() since it is deprecated and no longer available in angular-l10n.
 * Instead of replacing @Language decorator we can replace `translate` pipe with `xTranslate` (where x means extension of)
 * which does this injection internally and uses L10nLocale instead
 */
@Injectable({ providedIn: 'root' })
@Pipe({ name: 'xTranslate', standalone: true })
export class TranslationPipe implements PipeTransform {
  constructor(
    public translationService: L10nTranslationService,
    @Inject(L10N_LOCALE) private locale: L10nLocale
  ) {}

  transform(text: string, args: { [key: string]: any } = {}): string {
    if (text == null || text === '') {
      return null;
    }
    return this.translationService.translate(text, args, this.locale.language);
  }
}
